export default __webpack_public_path__ + "static/media/SilverFoilRocket_01.e2f5cd79.png";